// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandKeywords_container__3Vv7r","pageHeader":"BrandKeywords_pageHeader__MxSi9","add":"BrandKeywords_add__1zShy"};